import { useQuery } from '@tanstack/react-query';
import { surveySubmissionSummaryQueryOptions } from '../api/surveys.api';
import type { SurveySubmissionFilters } from '../types/survey.types';
import { StatCardGrid } from '@/components/common/StatCardGrid';

interface SurveySubmissionSummaryProps {
  surveyId: number;
  filters: SurveySubmissionFilters;
}

export function SurveySubmissionSummary({ surveyId, filters }: SurveySubmissionSummaryProps) {
  const { data, isLoading, isError } = useQuery(
    surveySubmissionSummaryQueryOptions(surveyId, filters),
  );

  return (
    <StatCardGrid
      stats={[
        {
          key: 'questions',
          label: 'Questions',
          value: data?.totalQuestions,
        },
        {
          key: 'respondents',
          label: 'Respondents',
          value: data?.totalRespondents,
        },
        {
          key: 'responses',
          label: 'Responses',
          value: data?.totalResponses,
        },
      ]}
      isLoading={isLoading}
      isError={isError}
    />
  );
}
